import React from 'react';
import PropTypes from 'prop-types';

import Select from '../../components/Select';
import StorePresenter from '../../presenters/StorePresenter';
import OneLineSkeleton from '../../components/Skeletons/OneLineSkeleton';
import { useFetchStatus } from '../../utils/fetchStatusUtils';

const StoreSelect = (props) => {
  const { stores, onChange, value, loadingState, required, defaultOption } = props;
  const { isFulfilled } = useFetchStatus(loadingState);
  if (!isFulfilled) {
    return <OneLineSkeleton width={350} height={20} />;
  }
  const storesOptions = stores.map((store) => {
    return {
      value: StorePresenter.id(store),
      label: StorePresenter.name(store),
    };
  });

  const allStoresOption = { value: '', label: 'All stores' };

  return (
    <div>
      <Select
        id="storeIdEq"
        onChange={onChange}
        value={value}
        className="input-underlined"
        options={storesOptions}
        defaultOption={defaultOption || allStoresOption}
        required={required}
      />
    </div>
  );
};

export default StoreSelect;

StoreSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  loadingState: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

StoreSelect.defaultProps = {
  stores: {},
  required: false,
};
